import axios from "axios";
import holidays from "../../models/gruposDeFeriado/holidays";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getHolidays() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/feriados`, { headers }).then(({ data }) =>
      data.map((item) => {
        return holidays.fromJson(item);
      })
    );
  }

  async getHolidaysCurrentYearNager(year) {
    const url = `https://date.nager.at/api/v3/PublicHolidays`;
    try {
      const response = await axios.get(`${url}/${year}/AR`);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  getHolidayId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/feriados/${id}`, { headers })
      .then(({ data }) => data);
  }

  async addHolidays(data) {
    try {
      let token = localStorage.getItem("token");
      const url = this.config.apiUrl;

      let headers = {
        Authorization: `Bearer ${token}`,
      };

      const promises = data.map(async (element) => {
        const payload = {
          nombre: element.localName,
          fecha: new Date(`${element.date}T00:00:00.000Z`).toISOString(),
          fijo: element.fixed,
        };

        return axios.post(`${url}/feriados`, payload, { headers });
      });

      const responses = await Promise.all(promises);

      const responseData = responses.map((response) => response.data);

      return true;
    } catch (error) {
      console.error("Error adding holidays:", error);
      return false;
    }
  }

  addHoliday(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
      fecha: data.fecha,
      fijo: data.fijo,
    };

    if (data.gruposFer && data.gruposFer.length > 0) {
      payload.gruposFer = data.gruposFer;
    }
    return axios.post(`${url}/feriados`, payload, { headers });
  }

  deleteHoliday(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/feriados/${id}`, { headers });
  }

  editHoliday(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
      fecha: data.fecha,
      fijo: data.fijo,
      gruposFer: data.gruposFer,
    };

    return axios
      .patch(`${url}/feriados/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
}

export default service;
